import { MouseEvent } from "react";

import CloseIcon from "@/common/images/icons/cross.svg?react";
import SecondaryButton from "components/core/SecondaryButton";

import classes from "./RemovableTag.module.css";

interface IProps {
  tag: string;
  variant?: "default" | "active";
  onRemove?: (tag: string) => (event: MouseEvent) => void;
}

export const RemovableTag = ({ tag, variant, onRemove }: IProps) => {
  return (
    <SecondaryButton variant={variant} type="button">
      <span>{tag}</span>
      {onRemove && (
        <span className={classes.remove} onClick={onRemove(tag)}>
          <CloseIcon className={classes.removeIcon} />
        </span>
      )}
    </SecondaryButton>
  );
};
